import addCalendarEventsAndNotify from './addCalendarEventsAndNotify';
import deleteCalendarEventsAndNotify from './deleteCalendarEventsAndNotify';
import deleteCalendarEventsByInstanceKeysAndNotify from './deleteCalendarEventsByInstanceKeysAndNotify';
import findCachedEventWithInstanceKeyOrItemId from './findCachedEventWithInstanceKeyOrItemId';
import { CalendarEvent } from 'mini-calendar-event-types';

/**
 * Add or Modify calendar events on single item notification
 * @param calendarEvent The calendar event to be upserted in the events cache
 */
export default function upsertCalendarEvent(calendarEvent: CalendarEvent) {
    const cachedEvent = findCachedEventWithInstanceKeyOrItemId(calendarEvent);

    if (cachedEvent) {
        if (cachedEvent.IsRecurring) {
            // Even though the notification is for a single item, we may be dealing with something that used to be a series and
            // has just been turned into a single item.
            deleteCalendarEventsByInstanceKeysAndNotify([cachedEvent.InstanceKey]);
        } else {
            deleteCalendarEventsAndNotify([cachedEvent]);
        }
    }

    addCalendarEventsAndNotify([calendarEvent]);
}
